import React, { Component } from 'react';
import Modal from 'react-modal';
import styles from '../Report/Report.less';
import i18next from 'i18next';
import deliveryStyles from './Delivery.less';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import { Grid, Table, TableHeaderRow, TableSummaryRow, TableColumnResizing } from '@devexpress/dx-react-grid-bootstrap4';
import { SummaryState, IntegratedSummary } from '@devexpress/dx-react-grid';
import { Button, DropdownButton } from 'react-bootstrap';
import CancelRequest from './CancelRequest';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';
import { connect } from 'react-redux';
import { getFormattedRate, getMinMaxFractionDigits } from '../../utils/utils';

const renderFormattedNumber = (data, value, roundoff, key) => {
    const config = getMinMaxFractionDigits(data[key])
    return getFormattedRate(value, config.minimumFractionDigits, config.maximumFractionDigits, true, roundoff)
}

const columnsToFormat = { 
    GQ: { format: 'stockQtyFormat', roundOff: 'stockQtyRound' }, 
    PAMT: { format: 'stockRateFormat', roundOff: 'stockRateRound' },
    FC_PAMT: { format: 'stockRateFormat', roundOff: 'stockRateRound' } 
};

@connect(
  state => ({
  userDetail: state.auth.userDetail,
}),
{ })

class ViewStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      cancelReq: false,
      columns: [
        { name:'SC', title:i18next.t('stock') },
        { name:'PQ', title:i18next.t('Pcs')},
        { name:'GQ', title:i18next.t('qty') + ' ' + this.props.userDetail.CompanyBaseName, type: 'number'},
        { name:'PREMUNIT', title:i18next.t('premRate')},
        { name:'PAMT', title:i18next.t('premAmt') + ' (USD)', type: 'number'},
      ],
      tableColumnExtensions: [
        { columnName:'SC', width:210 },
        { columnName:'PQ', width:60, align:'right'  },
        { columnName:'GQ', width:80, align:'right' },
        { columnName:'PREMUNIT', width:110, align:'left' },
        { columnName:'PAMT', width:120, align:'right' },
      ],
      numericColumns: ["TOTAL_GQ", "TOTAL_PAMT"],
    };
  }

  handleCloseIconClick = () => {
    this.props.onClose();
  };

  onClickCancelRequest = () => {
    this.props.onClose();
    this.setState({ cancelReq: true });
  };

  handleCloseCancel = () => {
    this.setState({ cancelReq: false });
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.rowData !== nextProps.rowData) {
      const transformedRows = nextProps.rowData.DATA.map(item => ({
        ...item,
        PREMUNIT: item.PUNIT === "" ? `${item.PREM}` : `${item.PREM}/${item.PUNIT}`
      }));
      this.setState({ rows: transformedRows });
    }
  }

  render() {
    const { isOpen, rowData } = this.props;
    const orderStatus = rowData ? rowData.STATUSDESC : ''
    const { cancelReq, columns, rows, tableColumnExtensions } = this.state;
    const totalSummaryItems = [
      { columnName: 'GQ', type: 'sum', textAlign:'right' },
      { columnName: 'PAMT', type: 'sum', textAlign:'right' },
      { columnName: 'FC_PAMT', type: 'sum', textAlign:'right' }
    ];

    const currency = rowData?.CURRENCY || 'USD';

    return (
      <>
        <Modal
          isOpen={isOpen}
          onRequestClose={this.props.onClose}
          contentLabel="View Modal"
          closeTimeoutMS={350}
          className={`${deliveryStyles.delModals} ${deliveryStyles.viewStatusModal}`}
          overlayClassName="overlay"
          shouldCloseOnOverlayClick={false}
        >
          <div className={`${styles.reporthead} ${deliveryStyles.modalHeader} reportheader`}>
            <div className="rptHeader addWidgetTitle">Delivery Request: {rowData?.DRN}</div>
            <span onClick={this.handleCloseIconClick} id="closeViewModal" className={`${styles.closeIcon} closeIcon commonCloseIcon`}>
              <MUIIconWithTooltip icon={"Close"} className={"closeBtn"} title={i18next.t("close")} />
            </span>
          </div>

          <div className={deliveryStyles.modalBody}>
            <div className="row">
                <div className="col-6">
                  <label>{i18next.t('cmdty')}</label>
                  <p>{rowData?.CMDTY}</p>
                </div>

                <div className="col-6">
                  <label>{i18next.t('collectionDateTime')}</label>
                  <p>{rowData?.DATE + ' ' + rowData?.TIME + ' ' + rowData?.TZ}</p>
                </div>
            </div>

            <div className="row">
              <div id="viewDelReqTable" className={`col-12 mb-3 ${deliveryStyles.viewDelReqTable}`}>
                <Grid rows={rows} columns={columns}>
                  <SummaryState totalItems={totalSummaryItems} />
                  <IntegratedSummary />
                  <Table columnExtensions={tableColumnExtensions} />
                  <TableHeaderRow />
                  <TableSummaryRow
                    totalCellComponent={({ column, children, ...restProps }) => {
                      let content = children;
                      const { format, roundOff } = columnsToFormat[column.name] || {};
                      if (column.name === "SC") {
                        content = (<strong>{i18next.t('total')}</strong>);
                      } else if (column.name === "PAMT") {
                        content = <strong>{renderFormattedNumber(rowData, rowData?.TOTAL_PAMT, rowData[roundOff], format)}</strong>;
                      } else if (column.name === "GQ") {
                        content = <strong>{renderFormattedNumber(rowData, rowData?.TOTAL_GQ, rowData[roundOff], format)}</strong>;
                      }
                      // else if (column.name === "FC_PAMT") {
                      //   content = <strong>{renderFormattedNumber(rowData, rowData?.TOTAL_FC_PAMT, rowData[roundOff], format)}</strong>;
                      // }

                      return <Table.Cell {...restProps} style={{
                        verticalAlign: "middle",
                        fontWeight: "bold"
                      }}>{content}</Table.Cell>;
                    }}
                    itemComponent={({ value }) => <>{value}</>}
                  />
                </Grid>
              </div>
            </div>

            <div className={`row ${deliveryStyles.amtPayable}`}>
              <div className={deliveryStyles.amtPayableRow}>
                <label className={deliveryStyles.modalFieldLabel}>{i18next.t('amtPayable')}</label>
              </div>
              <div className={deliveryStyles.amtPayableRow}>
                {currency && <label className={deliveryStyles.modalFieldLabel}>{"(" + currency + "):"}</label>}
              </div>
              <div className={deliveryStyles.amtPayableRow}>
                {rowData?.TOTAL_FC_PAMT &&
                 (() => {
                   const { format, roundOff } = columnsToFormat['FC_PAMT'] || {};
                   return (
                     <p className={deliveryStyles.payableAmt}>
                       {renderFormattedNumber(rowData, rowData?.TOTAL_FC_PAMT, rowData[roundOff], format)}
                     </p>
                   );
                 })()
                }
              </div>
            </div>
              
            <div className="row">
              <div className="col-12">
                <label>{i18next.t('location')}</label>
                <p>{rowData?.LOC_DESC}</p>
              </div>
            </div>

            <div className="row mb-3">
              {rowData?.LOC_ADDRESS && (
                <div className="col-7">
                  <label>{i18next.t('Address')}</label>
                  <p>{rowData?.LOC_ADDRESS}</p>
                </div>
              )}

              {Array.isArray(rowData?.LOC_CONTACTS) && rowData.LOC_CONTACTS.length > 0 && (
                <div className="col-5">
                  <label>{i18next.t('contactNo')}</label>
                  <ul className="list-unstyled mb-0 ps-0" style={{ paddingLeft: '0px' }}>
                    {rowData.LOC_CONTACTS.map((contact, idx) => (
                      <li key={idx}>{contact}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="row">
              { rowData?.RMK && (orderStatus === 'Pending' || orderStatus === 'Delivered') && (
                <div className="col-12">
                  <label>{i18next.t("comments")}</label>
                  <p>{rowData?.RMK}</p>
                </div>
              )}

              {(orderStatus === 'Delivered' || orderStatus === 'Cancelled') && (
                <div className="col-12">
                  <div className="row">
                    <div className="col-3">
                      <label>{i18next.t("status")}</label>
                      <p>{orderStatus}</p>
                    </div>

                    {(orderStatus === 'Cancelled' || orderStatus === 'Delivered' && Number(rowData?.ADD_CHARGES) !== 0) && (
                      <div className="col-4">
                        <label>{orderStatus === 'Cancelled' ? `${i18next.t("cancelChrg")} (${rowData?.CURRENCY || 'USD'})` : `${i18next.t("additionalCharges")} (${rowData?.CURRENCY || 'USD'})`}</label>
                        <p>{rowData?.ADD_CHARGES}</p>
                      </div>
                    )}

                    {Array.isArray(rowData?.DOCS) && rowData.DOCS.length > 0 && (
                      <div className="col-5">
                        <label>{i18next.t("generatedDocs")}</label>
                        <p>{rowData.DOCS.join(' ')}</p>
                      </div>
                    )}

                  </div>
                </div>
              )}

              {orderStatus === 'Cancelled. Approval Pending' && (
                <div className="col-12">
                  <label>{i18next.t("status")}</label>
                  <p>Cancelled. Approval Pending</p>
                </div>
              )}

              {(orderStatus === 'Cancelled. Approval Pending' || orderStatus === 'Cancelled') && (
                <div className="col-12">
                  <label>{i18next.t("reasonForCancel")}</label>
                  <p>{rowData?.ADD_RMK}</p>
                </div>
              )}

              <div className={`col-12 ${deliveryStyles.modalFooter} ${deliveryStyles.actionsRow} ${orderStatus === 'Pending' && deliveryStyles.pendingActions}`}>
                { this.props.userDetail.canTraderCancelDelivery ? orderStatus === 'Pending' && (
                  <Button onClick={this.onClickCancelRequest} className={deliveryStyles.cancelReq}>
                    {i18next.t("cancelReq")}
                  </Button>
                ): <div></div> }

                <Button onClick={this.handleCloseIconClick} className={deliveryStyles.close}>
                  {i18next.t("close")}
                </Button>
              </div>
            </div>
          </div>
        </Modal>

        {cancelReq && (
          <CancelRequest isOpen={cancelReq} onClose={this.handleCloseCancel} rowData={rowData}/>
        )}
      </>
    );
  }
}

export default ViewStatus;
